(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/bingo/assets/javascripts/views/mybets/betrow.js') >= 0) return;  svs.modules.push('/modules/bingo/assets/javascripts/views/mybets/betrow.js');

(function(Backbone, _, svs) {
  'use strict';

  svs.bingo.views.BetRow = Marionette.View.extend({
    tagName: 'li',
    isCurrent: false,

    className:
      'list-group-item list-group-item-table clickable-list-group-item-default',
    events: {
      click: 'onRowClick'
    },

    template: function(data) {
      return svs.bingo.templates.betrow(data);
    },

    initialize: function() {
      this.isCurrent = Backbone.history.fragment.includes(
        this.model.get('wagerId')
      );
      if (this.isCurrent) {
        this.$el.addClass('clickable-active default-cursor');
      }
    },

    onRowClick: function() {
      if (this.isCurrent) return;
      svs.components.headerslidedownmenu.hide();
      svs.bingo.router.navigate(
        'mina-spel/pagaende/' + this.model.get('wagerId'),
        { trigger: false }
      );
      location.reload();
    }
  });
})(Backbone, _, svs);


 })(window);